(() => {
  const fi = document.documentElement.lang.startsWith('fi');
  const money = new Intl.NumberFormat(fi ? 'fi-FI' : 'en-IE', { style: 'currency', currency: 'EUR' });
  function render(cart) {
    if (!Number.isFinite(cart?.total_price)) return;
    document.querySelectorAll('gastro-shipping-progress').forEach(element => {
      element.hidden = cart.currency !== 'EUR';
      const remaining = Math.max(0, 50000 - cart.total_price);
      element.querySelector('[data-shipping-label]').textContent = remaining
        ? (fi ? 'Ilmaiseen toimitukseen vielä' : 'Away from free delivery')
        : (fi ? 'Ilmainen toimitus saavutettu' : 'Free delivery unlocked');
      const amount = element.querySelector('[data-shipping-remaining]');
      amount.hidden = remaining === 0;
      amount.textContent = money.format(remaining / 100);
      element.querySelector('progress').value = Math.max(0, Math.min(50000, cart.total_price));
    });
  }
  let pending;
  function refresh() {
    if (pending || !document.querySelector('gastro-shipping-progress')) return;
    pending = fetch((window.Shopify?.routes?.root || '/') + 'cart.js')
      .then(response => response.ok ? response.json() : null)
      .then(render).catch(() => {}).finally(() => { pending = null; });
  }
  window.addEventListener('gastro:cart-updated', refresh);
  window.addEventListener('pageshow', event => { if (event.persisted) refresh(); });
  document.addEventListener('cart:refresh', refresh);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, event => event.cartData?.total_price !== undefined ? render(event.cartData) : refresh());
  }
})();
